import * as Yup from 'yup'

export default Yup.object().shape({
  email: Yup.string().required('Required.').email('Please enter a valid email address.')
})
